module.exports = __webpack_public_path__ + "static/img/daixin@2x.6e7a23d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/daixin@2x.png
// module id = B+Sq
// module chunks = 1